var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackend2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.18,78.37V74.08L441,73.87a11.53,11.53,0,0,0-1.65-4l1.42-1.71-3-3L436,66.57a11.53,11.53,0,0,0-4-1.65l-.2-2.21h-4.3l-.21,2.21a11.48,11.48,0,0,0-4,1.65l-1.72-1.42-3,3L420,69.9a11.34,11.34,0,0,0-1.65,4l-2.21.21v4.29l2.21.21a11.34,11.34,0,0,0,1.65,4l-1.42,1.71,3,3,1.72-1.42a11.48,11.48,0,0,0,4,1.65l.21,2.21h4.3l.2-2.21a11.53,11.53,0,0,0,4-1.65l1.72,1.42,3-3-1.42-1.71a11.53,11.53,0,0,0,1.65-4ZM429.67,82a5.82,5.82,0,1,1,5.81-5.82A5.82,5.82,0,0,1,429.67,82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.59,90.49V87.13L458.85,87a9,9,0,0,0-1.29-3.1l1.12-1.35-2.38-2.38L455,81.25a8.93,8.93,0,0,0-3.11-1.3l-.16-1.73h-3.36L448.15,80a9,9,0,0,0-3.11,1.3l-1.34-1.12-2.38,2.38,1.11,1.35a9.14,9.14,0,0,0-1.29,3.1l-1.73.17v3.36l1.73.17a9,9,0,0,0,1.29,3.1l-1.11,1.35,2.38,2.38L445,96.37a9,9,0,0,0,3.11,1.3l.17,1.73h3.36l.16-1.73a8.93,8.93,0,0,0,3.11-1.3l1.35,1.12,2.38-2.38-1.12-1.35a9,9,0,0,0,1.29-3.1ZM450,93.37a4.56,4.56,0,1,1,4.55-4.56A4.56,4.56,0,0,1,450,93.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.18,100.05V97.22l-1.45-.14a7.46,7.46,0,0,0-1.09-2.61l.94-1.13-2-2-1.13.94a7.65,7.65,0,0,0-2.61-1.09l-.14-1.45h-2.82l-.14,1.45a7.65,7.65,0,0,0-2.61,1.09L429,91.34l-2,2,.93,1.13a7.63,7.63,0,0,0-1.08,2.61l-1.46.14v2.83l1.46.13a7.63,7.63,0,0,0,1.08,2.61l-.93,1.13,2,2,1.13-.93a7.44,7.44,0,0,0,2.61,1.08l.14,1.46h2.82l.14-1.46a7.44,7.44,0,0,0,2.61-1.08l1.13.93,2-2-.94-1.13a7.46,7.46,0,0,0,1.09-2.61Zm-8.89,2.41a3.83,3.83,0,1,1,3.82-3.83A3.83,3.83,0,0,1,434.29,102.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.47 381.47 72.81 232.98 72.81 381.47 78.81 381.47 78.81 232.05 101.19 381.47 107.61 381.47 79.61 194.44 78.81 194.56 78.81 188.47 72.81 188.47 72.81 194.53 71.99 194.44 43.92 381.47 50.47 381.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.56 215.18 44.74 215.18 49.75 163.53 101.56 163.53 106.56 215.18",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(64.11 78.4)",
    style: {
      fontSize: 12,
      fill: "#e0e0e0",
      fontFamily: "Bebas"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 4.4,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.81,
    y: 0,
    style: {
      letterSpacing: "0.017740885416666668em"
    }
  }, "11"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.41,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.81,
    y: 0,
    style: {
      letterSpacing: "0.023478190104166668em"
    }
  }, "00"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.8,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.21,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 47.61,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 54.01,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 58.41,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 64.82,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 69.22,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "00"), /*#__PURE__*/React.createElement("tspan", {
    x: 82.21,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 88.62,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 93.01,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 99.42,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 103.82,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 110.23,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 114.63,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 121.04,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 125.43,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 131.84,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 136.24,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 142.65,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 147.04,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 153.45,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 157.85,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 164.26,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 168.66,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 175.07,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 179.46,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "000000"), /*#__PURE__*/React.createElement("tspan", {
    x: 218.43,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 224.84,
    y: 0,
    style: {
      letterSpacing: "0.017740885416666668em"
    }
  }, "11111"), /*#__PURE__*/React.createElement("tspan", {
    x: 246.36,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 250.75,
    y: 0,
    style: {
      letterSpacing: "0.023478190104166668em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 257.25,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 263.66,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 268.05,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 274.46,
    y: 0,
    style: {
      letterSpacing: "0.017740885416666668em"
    }
  }, "111"), /*#__PURE__*/React.createElement("tspan", {
    x: 287.37,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 291.77,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 298.18,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 302.58,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 308.99,
    y: 0
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(142.56 319.29)",
    style: {
      fontSize: 12,
      fill: "#e0e0e0",
      fontFamily: "Bebas"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 4.4,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.81,
    y: 0,
    style: {
      letterSpacing: "0.017740885416666668em"
    }
  }, "11"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.41,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.81,
    y: 0,
    style: {
      letterSpacing: "0.023478190104166668em"
    }
  }, "00"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.8,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.21,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 47.61,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 54.01,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 58.41,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 64.82,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 69.22,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "00"), /*#__PURE__*/React.createElement("tspan", {
    x: 82.21,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 88.62,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 93.01,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 99.42,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 103.82,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 110.23,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 114.63,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 121.04,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 125.43,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 131.84,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 136.24,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "00"), /*#__PURE__*/React.createElement("tspan", {
    x: 149.23,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 155.64,
    y: 0,
    style: {
      letterSpacing: "0.017740885416666668em"
    }
  }, "1111"), /*#__PURE__*/React.createElement("tspan", {
    x: 172.85,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 177.25,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 183.66,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 188.05,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 194.46,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 198.86,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 205.27,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 209.67,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "000"), /*#__PURE__*/React.createElement("tspan", {
    x: 229.15,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 235.56,
    y: 0,
    style: {
      letterSpacing: "0.017740885416666668em"
    }
  }, "11"), /*#__PURE__*/React.createElement("tspan", {
    x: 244.17,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 248.56,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 254.97,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 259.37,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 265.78,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 270.18,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "0000"), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 296.15,
    y: 0
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(85.45 115.43)",
    style: {
      fontSize: 12,
      fill: "#e0e0e0",
      fontFamily: "Bebas"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.41,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.81,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.22,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.61,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.02,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.42,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "00"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.41,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 51.82,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 56.21,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.62,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 67.02,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.43,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 77.83,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.24,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 88.63,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "000000"), /*#__PURE__*/React.createElement("tspan", {
    x: 127.6,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 134.01,
    y: 0,
    style: {
      letterSpacing: "0.017740885416666668em"
    }
  }, "11111"), /*#__PURE__*/React.createElement("tspan", {
    x: 155.53,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 159.92,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 166.42,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 172.83,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 177.22,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 183.63,
    y: 0,
    style: {
      letterSpacing: "0.017740885416666668em"
    }
  }, "111"), /*#__PURE__*/React.createElement("tspan", {
    x: 196.54,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 200.94,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 207.35,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 211.75,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 218.16,
    y: 0
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(163.24 361.49)",
    style: {
      fontSize: 12,
      fill: "#e0e0e0",
      fontFamily: "Bebas"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.41,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.81,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.22,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.61,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.02,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.42,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "00"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.41,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 51.82,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 56.21,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.62,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 67.02,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.43,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 77.83,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.24,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 88.63,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "000000"), /*#__PURE__*/React.createElement("tspan", {
    x: 127.6,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 134.01,
    y: 0,
    style: {
      letterSpacing: "0.017740885416666668em"
    }
  }, "11111"), /*#__PURE__*/React.createElement("tspan", {
    x: 155.53,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 159.92,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 166.42,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 172.83,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 177.22,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 183.63,
    y: 0,
    style: {
      letterSpacing: "0.017740885416666668em"
    }
  }, "111"), /*#__PURE__*/React.createElement("tspan", {
    x: 196.54,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 200.94,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 207.35,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 211.75,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 218.16,
    y: 0
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(227.31 339.16)",
    style: {
      fontSize: 12,
      fill: "#e0e0e0",
      fontFamily: "Bebas"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.41,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.81,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.22,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.61,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.02,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.42,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "00"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.41,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 51.82,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 56.21,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.62,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 67.02,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.43,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 77.83,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.24,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 88.63,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "000000"), /*#__PURE__*/React.createElement("tspan", {
    x: 127.6,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 134.01,
    y: 0,
    style: {
      letterSpacing: "0.017740885416666668em"
    }
  }, "11111"), /*#__PURE__*/React.createElement("tspan", {
    x: 155.53,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 159.92,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 166.42,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 172.83,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 177.22,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 183.63,
    y: 0,
    style: {
      letterSpacing: "0.017740885416666668em"
    }
  }, "111"), /*#__PURE__*/React.createElement("tspan", {
    x: 196.54,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 200.94,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 207.35,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 211.75,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 218.16,
    y: 0
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(85.45 134)",
    style: {
      fontSize: 12,
      fill: "#e0e0e0",
      fontFamily: "Bebas"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.41,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.81,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.22,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.61,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.02,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.42,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "00"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.41,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 51.82,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 56.21,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.62,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 67.02,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.43,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 77.83,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.24,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 88.63,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 95.04,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 99.44,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 105.85,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 110.25,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 116.65,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 121.05,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 127.46,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 131.86,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 138.27,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 142.66,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "000000"), /*#__PURE__*/React.createElement("tspan", {
    x: 181.63,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 188.04,
    y: 0,
    style: {
      letterSpacing: "0.017740885416666668em"
    }
  }, "11111"), /*#__PURE__*/React.createElement("tspan", {
    x: 209.56,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 213.95,
    y: 0,
    style: {
      letterSpacing: "0.0234375em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 220.45,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 226.86,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 231.25,
    y: 0,
    style: {
      letterSpacing: "0.016357421875em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 237.66,
    y: 0,
    style: {
      letterSpacing: "0.017740885416666668em"
    }
  }, "111"), /*#__PURE__*/React.createElement("tspan", {
    x: 250.58,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 254.97,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 261.38,
    y: 0,
    style: {
      letterSpacing: "0.025553385416666668em"
    }
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 265.78,
    y: 0,
    style: {
      letterSpacing: "0.016316731770833332em"
    }
  }, "0"), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 272.19,
    y: 0
  }, "1")))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444,92.61V293.86a9.36,9.36,0,0,1-9,9.14H145.39c-4.81,0-8.39-4.32-8.39-9.14V92.61A8.36,8.36,0,0,1,145.39,84H435A8.91,8.91,0,0,1,444,92.61Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,117.69V293.86a9.36,9.36,0,0,1-9,9.14H145.39c-4.81,0-8.39-4.32-8.39-9.14V225.29c25.48-49,86.22-56.94,157.33-28.29C395,237.56,437.93,182.51,444,117.69Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bar--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.92,280H218a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5H364.92a5,5,0,0,1,5,5h0A5,5,0,0,1,364.92,280Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,279a4,4,0,1,1,0-8h86.84a4,4,0,1,1,0,8Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,279a4,4,0,1,1,0-8h86.84a4,4,0,1,1,0,8Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.93,287.26c9.32,7.49,6.07,43.24,7.82,48.74S177,346,177,346l-10.46,12.25s-8.75-1.52-15.4-15.77S159.93,287.26,159.93,287.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.93,287.26c9.32,7.49,6.07,43.24,7.82,48.74S177,346,177,346l-10.46,12.25s-8.75-1.52-15.4-15.77S159.93,287.26,159.93,287.26Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,365.75s67-18.69,75.38,4.82S173,412.81,139.37,414,92,391.51,101.92,369.08Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,365.75s67-18.69,75.38,4.82S173,412.81,139.37,414,92,391.51,101.92,369.08Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,403.8a.23.23,0,0,1-.25,0,.17.17,0,0,1-.06-.21c.11-.37,1.23-3.61,2.35-3.95a.74.74,0,0,1,.68.2,1.15,1.15,0,0,1,.39,1.09,3,3,0,0,1-1.05,1.52A12.94,12.94,0,0,1,215.67,403.8Zm.29-.63a4.76,4.76,0,0,0,2.39-2.31.73.73,0,0,0-.28-.74.22.22,0,0,0-.26-.07.61.61,0,0,0-.26.15A9.17,9.17,0,0,0,216,403.17Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.61,403.84a.2.2,0,0,1-.21-.06c-.11-.09-1.66-2.06-1.4-3.38a1.25,1.25,0,0,1,.53-.81.72.72,0,0,1,.9-.08c.81.57.71,3.19.31,4.19l0,.1Zm-.89-3.85a.82.82,0,0,0-.26.47c-.17.84.61,2.1,1,2.7.25-1.12.17-3-.31-3.29-.05,0-.15-.11-.39.06l-.08.06Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.4,415.69a.24.24,0,0,1,.18-.17.18.18,0,0,1,.19.11c.2.34,1.73,3.4,1.18,4.44a.68.68,0,0,1-.61.34,1.12,1.12,0,0,1-1.05-.47,3,3,0,0,1-.35-1.82A12.7,12.7,0,0,1,147.4,415.69Zm.24.64a4.83,4.83,0,0,0,0,3.33.74.74,0,0,0,.73.32.25.25,0,0,0,.24-.14,1,1,0,0,0,.07-.29A9.47,9.47,0,0,0,147.64,416.33Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.63 393.07 151.78 401.76 146.09 405.93 149.8 412.42 155.58 409.26 169.69 401.54 163.63 393.07",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.64,412.22l-3.58-7.89a.85.85,0,0,0-1.15-.41l-3.86,1.89s-5.37,2.17-6,3.91c-2,5.1,5.49,22.75,7.82,22.76.85,0,1.36-1.32,1.48-2.16.37-2.68.44-9.4.78-11.63.4-2.6,3-4.6,4.25-5.4A.86.86,0,0,0,151.64,412.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.41,415.62a.21.21,0,0,1,.19-.11c.14,0,2.63.25,3.4,1.36a1.28,1.28,0,0,1,.2.95.72.72,0,0,1-.57.7c-1,.18-2.78-1.72-3.21-2.7l0-.09A.21.21,0,0,1,147.41,415.62Zm3.37,2.06a.8.8,0,0,0-.15-.52c-.48-.7-1.93-1-2.65-1.15.62,1,2,2.2,2.56,2.09.06,0,.18,0,.23-.32v-.1Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.63 393.07 151.78 401.76 155.58 409.26 169.69 401.54 163.63 393.07",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.28 409.75 162.18 408.88 155.71 396.52 152.09 400.21 158.28 409.75",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.28 409.75 162.18 408.88 155.71 396.52 152.09 400.21 158.28 409.75",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.15 408.03 202.65 410.42 209.62 411.57 211.65 404.37 205.35 402.46 189.97 397.78 188.15 408.03",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.23,403.2l-3.14,8.07a.87.87,0,0,0,.51,1.12l4.05,1.43s5.31,2.32,7,1.58c5-2.16,12.42-19.84,10.79-21.51-.6-.61-1.89-.05-2.58.46-2.17,1.6-7,6.26-8.85,7.57-2.14,1.54-5.41,1.06-6.83.75A.84.84,0,0,0,210.23,403.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.15 408.03 202.65 410.42 205.35 402.46 189.97 397.78 188.15 408.03",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.85,401s-60.28-35.56-80.68-34.61S100,387.6,108.41,398.85s24,14,24,14-10.58-15-9.05-19.16,7.36,9.94,7.36,9.94,37.35,4.89,69.89,7.65Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.81 400.04 200.46 397.79 196.16 411 201.32 411 203.81 400.04",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.81 400.04 200.46 397.79 196.16 411 201.32 411 203.81 400.04",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.89,372c-10.91-21-7.44-52.95,2-84.74-6.6-5.51-32.93-9.23-53-3.39,0,0-12.74,47.21-11.24,98.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.73,292.42c-8.77,0-14.48-9.2-14.48-9.2,11.5-4,11.54-16.17,11.54-16.17l4.43,4.33,6.31,6.18c-5.25,3.72-2.77,6.94-1.1,8.37a7.68,7.68,0,0,0,1.1.82S143.5,292.42,134.73,292.42Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.43,285.93c-10.76,1.21-10-14.9-10-14.9a27.39,27.39,0,0,1,4.82.35l6.31,6.18C137.28,281.28,139.76,284.5,141.43,285.93Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.83,255c-4.07,1.68-3.29,6.13,3.47,14.24,4.16-3.59,6.42-11.75,4.23-14.37S153.39,253.51,149.83,255Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.85,273v0a28.43,28.43,0,0,1-1.3,3.18c-4,8.19-15.58,9.78-20.7,1.68l-.06-.08c-3.38-5.45-2.11-10.54-.7-19.36a12.2,12.2,0,0,1,19-8.18C158.83,254.93,158.43,265.47,155.85,273Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.54,263.75c-.16.71.09,1.37.55,1.47s1-.38,1.12-1.09-.09-1.36-.54-1.47S145.74,263.06,145.54,263.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.58,265.57c-.16.7.09,1.36.56,1.46s1-.37,1.13-1.09-.1-1.37-.56-1.47S153.74,264.86,153.58,265.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.88,265.31a25.88,25.88,0,0,0,2,6.82c-1.54.88-3.53-.13-3.53-.13Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.91,260.72a.37.37,0,0,1-.25-.12.42.42,0,0,1,0-.6,4.21,4.21,0,0,1,3.77-1,.41.41,0,0,1,.29.5v0a.45.45,0,0,1-.53.29h0a3.35,3.35,0,0,0-3,.79A.44.44,0,0,1,143.91,260.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.85,263.68a.45.45,0,0,1-.32-.33,3.39,3.39,0,0,0-1.92-2.4.44.44,0,0,1-.26-.55.43.43,0,0,1,.54-.26,4.23,4.23,0,0,1,2.46,3,.42.42,0,0,1-.31.51h-.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.28,251.52c3.75,2.31,2.27,6.58-5.69,13.5-3.55-4.2-4.48-12.63-1.89-14.85S135,249.51,138.28,251.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.38,264.48a8.46,8.46,0,0,0,2.83,5.84c2.24,2,4.63.26,5.08-2.52.41-2.51-.28-6.55-3-7.43S127.23,261.73,127.38,264.48Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.53,272.09s.92,3.18,5.18,3.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.557248px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.19,265.37a3,3,0,1,1-3-3A3,3,0,0,1,150.19,265.37Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.557248px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.36,267.05a3,3,0,1,1-3-3A3,3,0,0,1,158.36,267.05Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.557248px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.19,266.19a1.6,1.6,0,0,1,2.11.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.557248px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19,264.75s-8.69-3.66-10.31-4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.557248px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.61,250.29s-.9-7.06,6.31-8.23,16.64.64,19.56-.61a4.59,4.59,0,0,1-2.07,3.06s5.5,2,9.83.28c0,0-1.88,5.21-4.31,7.21H162s-4.1,3.92-9.09,4-9.69-6.79-14.63-4.48S130.61,250.29,130.61,250.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.85,273v0a28.43,28.43,0,0,1-1.3,3.18c-4,8.19-15.58,9.78-20.7,1.68l-.06-.08c-2.64-4.69-.53-9.81-.53-9.81l1.54-5,1.12-1.11s.26,5.07,1.05,6.5,5.29,1.85,6.21,2.1,3.1,2.85,4.18,3.55,5,.12,5.51.7S155.85,273,155.85,273Z",
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.89,353.5l20.74,23s22.92-.51,50.76,13.1c0,0,29.87-12.34,32.62-22.59s-62.71-3-62.71-3Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75,346.75,150,357.63S161.88,355,164,355s10.33,6.67,5.69,9-17.31,2.63-18.69,1.88-38.25-9.38-38.25-9.38Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.89,283.87c7.52-1.46-5.53,44.38-2.33,51.13s15.69,11,15.69,11l-5.75,12.69s-17-3.21-26.25-15S94.61,286.25,106.89,283.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.89,283.87c7.52-1.46-5.53,44.38-2.33,51.13s15.69,11,15.69,11l-5.75,12.69s-17-3.21-26.25-15S94.61,286.25,106.89,283.87Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.25 345 113.25 358.71 119.25 360 124.75 347.38 120.25 345",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.25 345 113.25 358.71 119.25 360 124.75 347.38 120.25 345",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,364v2.18a2.83,2.83,0,0,0,2.7,2.82h80.39a3,3,0,0,0,2.91-2.82V364Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,364v2.18a2.83,2.83,0,0,0,2.7,2.82h80.39a3,3,0,0,0,2.91-2.82V364Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,364v2.18a2.84,2.84,0,0,0,2.71,2.82h50.38a3,3,0,0,0,2.91-2.82V364Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.71,367h53.11a4.33,4.33,0,0,0,3.86-2.85l12.18-38.21a2.11,2.11,0,0,0-2-2.94H180.71a4.44,4.44,0,0,0-3.86,2.94L164.67,364.1A2.08,2.08,0,0,0,166.71,367Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.71,367h53.11a4.33,4.33,0,0,0,3.86-2.85l12.18-38.21a2.11,2.11,0,0,0-2-2.94H180.71a4.44,4.44,0,0,0-3.86,2.94L164.67,364.1A2.08,2.08,0,0,0,166.71,367Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.71,367h51.11a4.33,4.33,0,0,0,3.86-2.85l12.18-38.21a2.11,2.11,0,0,0-2-2.94H182.71a4.44,4.44,0,0,0-3.86,2.94L166.67,364.1A2.08,2.08,0,0,0,168.71,367Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.32 340.81 197.97 346.02 201.15 351.22 208.5 346.02 205.32 340.81",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tabs--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.12,
    y: 93.7,
    width: 84.73,
    height: 84.73,
    rx: 8.74,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.88,
    y: 84.4,
    width: 71,
    height: 71,
    rx: 7.33,
    style: {
      fill: "#ED5802",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.88,
    y: 84.4,
    width: 71,
    height: 71,
    rx: 7.33,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.85,111.7v-4.29l-2.21-.21a11.4,11.4,0,0,0-1.65-4l1.42-1.72-3-3-1.71,1.42a11.53,11.53,0,0,0-4-1.65L219.48,96h-4.29L215,98.25a11.53,11.53,0,0,0-4,1.65l-1.71-1.42-3,3,1.42,1.72a11.4,11.4,0,0,0-1.65,4l-2.21.21v4.29l2.21.21a11.53,11.53,0,0,0,1.65,4l-1.42,1.72,3,3,1.71-1.42a11.53,11.53,0,0,0,4,1.65l.21,2.21h4.29l.21-2.21a11.53,11.53,0,0,0,4-1.65l1.71,1.42,3-3L227,115.88a11.53,11.53,0,0,0,1.65-4Zm-13.51,3.67a5.82,5.82,0,1,1,5.81-5.81A5.82,5.82,0,0,1,217.34,115.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.25,123.83v-3.37l-1.73-.16a8.92,8.92,0,0,0-1.29-3.11l1.11-1.34L244,113.47l-1.34,1.11a8.92,8.92,0,0,0-3.11-1.29l-.16-1.74H236l-.16,1.74a8.92,8.92,0,0,0-3.11,1.29l-1.34-1.11L229,115.85l1.11,1.34a8.92,8.92,0,0,0-1.29,3.11l-1.73.16v3.37l1.73.16a8.92,8.92,0,0,0,1.29,3.11L229,128.44l2.38,2.38,1.34-1.11a8.92,8.92,0,0,0,3.11,1.29l.16,1.73h3.37l.16-1.73a8.92,8.92,0,0,0,3.11-1.29l1.34,1.11,2.38-2.38-1.11-1.34a8.92,8.92,0,0,0,1.29-3.11Zm-10.59,2.87a4.56,4.56,0,1,1,4.56-4.56A4.56,4.56,0,0,1,237.66,126.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.85,133.38v-2.83l-1.46-.13a7.44,7.44,0,0,0-1.08-2.61l.93-1.13-2-2-1.13.93a7.6,7.6,0,0,0-2.61-1.08l-.14-1.46h-2.83l-.14,1.46a7.6,7.6,0,0,0-2.61,1.08l-1.13-.93-2,2,.93,1.13a7.44,7.44,0,0,0-1.08,2.61l-1.46.13v2.83l1.46.14a7.6,7.6,0,0,0,1.08,2.61l-.93,1.13,2,2,1.13-.93a7.82,7.82,0,0,0,2.61,1.09l.14,1.45h2.83l.14-1.45a7.82,7.82,0,0,0,2.61-1.09l1.13.93,2-2-.93-1.13a7.6,7.6,0,0,0,1.08-2.61ZM222,135.79a3.83,3.83,0,1,1,3.82-3.82A3.82,3.82,0,0,1,222,135.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.88,
    y: 84.4,
    width: 71,
    height: 71,
    rx: 7.33,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 175.94,
    width: 78.33,
    height: 78.33,
    rx: 8.08,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.68,
    y: 171.75,
    width: 65.63,
    height: 65.63,
    rx: 6.77,
    style: {
      fill: "#ED5802",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.68,
    y: 171.75,
    width: 65.63,
    height: 65.63,
    rx: 6.77,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,215.11a2.37,2.37,0,1,1-2.36-2.37A2.37,2.37,0,0,1,349,215.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.43,191.47A23.52,23.52,0,0,0,322.9,215h18.79a4.43,4.43,0,0,1,4.74-4.64,5.11,5.11,0,0,1,1.41.27l8.81-10.23-6.22,12.1a4.46,4.46,0,0,1,.73,2.5H370A23.53,23.53,0,0,0,346.43,191.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.45,
    y: 171.75,
    width: 65.63,
    height: 65.63,
    rx: 6.77,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.7,
    y: 113.34,
    width: 68.73,
    height: 68.73,
    rx: 7.09,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.13,
    y: 107.28,
    width: 57.59,
    height: 57.59,
    rx: 5.94,
    style: {
      fill: "#ED5802",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.13,
    y: 107.28,
    width: 57.59,
    height: 57.59,
    rx: 5.94,
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,121.89a1.89,1.89,0,0,0-1.89-1.89H354.89a1.89,1.89,0,0,0-1.89,1.89v6.22a1.89,1.89,0,0,0,1.89,1.89h28.22a1.89,1.89,0,0,0,1.89-1.89Zm-9.32,3.37h-1.62v-1.62h1.62Zm4.33.81a1.63,1.63,0,1,1,1.62-1.62A1.62,1.62,0,0,1,380,126.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,132.89a1.89,1.89,0,0,0-1.89-1.89H354.89a1.89,1.89,0,0,0-1.89,1.89v6.22a1.89,1.89,0,0,0,1.89,1.89h28.22a1.89,1.89,0,0,0,1.89-1.89Zm-9.32,4h-1.62v-1.62h1.62Zm4.33.81a1.62,1.62,0,1,1,1.62-1.62A1.61,1.61,0,0,1,380,137.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,143.89a1.89,1.89,0,0,0-1.89-1.89H354.89a1.89,1.89,0,0,0-1.89,1.89v6.22a1.89,1.89,0,0,0,1.89,1.89h28.22a1.89,1.89,0,0,0,1.89-1.89Zm-9.32,4.62h-1.62v-1.62h1.62Zm4.33.81a1.62,1.62,0,1,1,1.62-1.62A1.62,1.62,0,0,1,380,149.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.57,
    y: 107.28,
    width: 57.59,
    height: 57.59,
    rx: 5.94,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.61,
    y: 166.56,
    width: 84.73,
    height: 84.73,
    rx: 8.74,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.49,
    y: 160.57,
    width: 71,
    height: 71,
    rx: 7.33,
    style: {
      fill: "#ED5802",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.49,
    y: 160.57,
    width: 71,
    height: 71,
    rx: 7.33,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.35,215.56h0a5.55,5.55,0,0,1,0-7.85l13-12.94a3.11,3.11,0,0,1,4.42,0l3.42,3.41a3.12,3.12,0,0,1,0,4.43l-12.95,12.95A5.53,5.53,0,0,1,245.35,215.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.21 194.25 266.66 191.7 281.29 177.07 284.48 176.43 283.84 179.62 269.21 194.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.77,197.64l-4.5-4.51a1,1,0,0,1,0-1.45h0a1,1,0,0,1,1.46,0l4.5,4.5a1,1,0,0,1,0,1.46h0A1,1,0,0,1,267.77,197.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.71,189l-6.17-6.19c1.15-3.09-1.18-6.89-3.71-7.89l-.05,4.76a2,2,0,0,1-2,2,2,2,0,0,1-2-2V175a6.58,6.58,0,0,0-4.1,5.76,6.11,6.11,0,0,0,5.34,6,5.27,5.27,0,0,0,3-.42l6.22,6.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.25,212.48v4.73a6.58,6.58,0,0,0,4.1-5.76,6.12,6.12,0,0,0-5.2-6.09,4.81,4.81,0,0,0-2.85.28l-6.46-6.48-3.54,3.54,6.42,6.43c-1.86,3.8,1,7,3.57,8v-4.7a2,2,0,0,1,2-2A2,2,0,0,1,282.25,212.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.49,
    y: 160.57,
    width: 71,
    height: 71,
    rx: 7.33,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.41,
    y: 62.13,
    width: 85.58,
    height: 85.58,
    rx: 8.83,
    transform: "translate(624.41 209.85) rotate(180)",
    style: {
      fill: "#ED5802",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.67,
    y: 75.73,
    width: 102.14,
    height: 102.14,
    rx: 10.54,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.41,
    y: 62.13,
    width: 85.58,
    height: 85.58,
    rx: 8.83,
    transform: "translate(624.41 209.85) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.18,78.41,286,88.69s3.31,36,26.21,42.75c22.91-6.75,26.22-42.75,26.22-42.75Zm-.66,34.86a1.85,1.85,0,0,1-1.45.73h0a1.82,1.82,0,0,1-1.45-.76l-9.19-12.67a1.81,1.81,0,1,1,2.93-2.13l7.76,10.68L322.8,92.38a1.81,1.81,0,0,1,2.53-.35,2,2,0,0,1,.35,2.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.03,
    y: 62.13,
    width: 85.58,
    height: 85.58,
    rx: 8.83,
    transform: "translate(631.64 209.85) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Promt-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.81,
    y: 284.93,
    width: 85.25,
    height: 57.53,
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.81,
    y: 284.93,
    width: 85.25,
    height: 57.53,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.39,
    y: 289.36,
    width: 81.87,
    height: 51.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.14,
    y: 297.29,
    width: 67.31,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.14,
    y: 301.54,
    width: 57.3,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.14,
    y: 305.79,
    width: 67.31,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.14,
    y: 310.04,
    width: 57.3,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.14,
    y: 314.29,
    width: 7.27,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.14,
    y: 318.54,
    width: 37.29,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.14,
    y: 322.79,
    width: 57.3,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.14,
    y: 327.04,
    width: 7.27,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.14,
    y: 331.29,
    width: 7.27,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Promt-1--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.98,
    y: 165.24,
    width: 85.25,
    height: 57.53,
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.98,
    y: 165.24,
    width: 85.25,
    height: 57.53,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.57,
    y: 169.67,
    width: 81.87,
    height: 51.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.32,
    y: 177.6,
    width: 67.31,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.32,
    y: 181.85,
    width: 57.3,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.32,
    y: 186.1,
    width: 67.31,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.32,
    y: 190.35,
    width: 57.3,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.32,
    y: 194.6,
    width: 7.27,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.32,
    y: 198.85,
    width: 37.29,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.32,
    y: 203.1,
    width: 57.3,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.32,
    y: 207.35,
    width: 7.27,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.32,
    y: 211.6,
    width: 7.27,
    height: 1.5,
    style: {
      fill: "#e0e0e0"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackend2);
export default __webpack_public_path__ + "static/media/backend2.24dcc0e0f1817f76e8097985b82e9121.svg";
export { ForwardRef as ReactComponent };